import { atom } from "recoil";
import { ExpenseModel } from "../Models/ExpenseModel";
export const expenseSate = atom({
  key: "expenseSate", // unique ID (with respect to other atoms/selectors)
  default: new ExpenseModel(), // default value (aka initial value)
});
